import PageBuilder from '@src/quince-site-common/src/organisms/pageBuilder'
import SectionRenderer from '@src/SectionRenderer'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'

import HomePageContext from './home-page-context'

function Home({ pageContext, isMobile }: { pageContext: unknown; isMobile: boolean }) {
  const pageData = pageContext
  const sectionRenderer = SectionRenderer({ tracker: 'home_page' })
  /**
   * const variant = useStatsigExperiment('home_template', 'control')
   * variant ? PageBuilder1 : PageBuilder2
   */

  return (
    <PageBuilder
      context={pageData as HomePageContext}
      selfContainerRenderer={sectionRenderer}
      className={'hide-horizontal-scroll'}
      isMobile={isMobile}
      trackEvent={TELEMETRY_EVENT_NAMES.HOME_PAGE_VIEW}
    />
  )
}

export { Home }
